<template>
    <div class="Suprimentos-Principal">
        <PageTitle icon="fa fa-car" main="Suprimentos"
            sub="Material em teste" />
        <div class="Sinistro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Lançamentos" active><JbSupMaterialTesteLancamento /></b-tab>                                                                                                                        
                    <b-tab title="Fornecedores"><Fornecedor /></b-tab>                                                                                                                        
                    <b-tab title="Indicadores"><JbSupMaterialTestePainel /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import JbSupMaterialTesteLancamento from '../sambaiba/JbSupMaterialTesteLancamento'
import Fornecedor from '../sambaiba/ClienteFornecedor'
import JbSupMaterialTestePainel from '../sambaiba/JbSupMaterialTestePainel'
export default {
    name: 'SinistroPrincipal',    
    components: { PageTitle, JbSupMaterialTesteLancamento,JbSupMaterialTestePainel,Fornecedor}
    
}
</script>

<style>

</style>






